import { useTranslation } from "react-i18next"
import { CanSendHealthData } from "app/PermissionChecker"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import { useSelector } from "react-redux"
import { selectCompanyGuid, selectCurrentUserGuid } from "features/auth/authSlice"
import { useEffect } from "react"
import { useLazyGetCurrentUserHealthStatusQuery } from "../dashboard/api/healthStatusApiSlice"
import TopicSubscriber from "app/ws/TopicSubriber"
import { NavLink } from "react-router-dom"

function MyHealthWidget() {

    const [t, i18n] = useTranslation(["absenceReport"])

    const companyGuid = useSelector(selectCompanyGuid)
    const userGuid = useSelector(selectCurrentUserGuid)

    const [getStatus, {
        data: statuses,
        isLoading: statusesIsLoading,
        isSuccess: statusesIsSuccess,
        isError
    }] = useLazyGetCurrentUserHealthStatusQuery();


    useEffect(() => {
        getStatus()
    }, [])


    function handlePayload() {
        getStatus()
    }

    return <HomeWidgetLayout
        title={"My Health"}
        isLoading={statusesIsLoading}
        permission={CanSendHealthData}
        content={
            <>
                {statusesIsSuccess &&
                    <HealthRealtTimeCard
                        healthData={statuses}
                        onAction={() => { }}
                    />
                }
                {
                    isError &&
                    <span>Nessun dato disponibile.</span>
                }
                <button className="btn btn-success mt-2" type="button">
                    <NavLink to={{ pathname: "/dashboard/health/history/my" }} className="nav-link"><i className="fa-solid fa-chart-simple"></i> {t("health:menu.data_ext")}</NavLink>
                </button>
                <TopicSubscriber
                    subTopic={`company/${companyGuid}/health/${userGuid}`}
                    onMessageReceived={handlePayload}
                />
            </>
        }
    />
}

export default MyHealthWidget


const HealthRealtTimeCard = (
    {
        healthData,
        onAction = (userGuid, actionType) => { }
    }
) => {

    const [t] = useTranslation(["global"])
    const { user, hr, isOffBody, lastUpdate, minHr, maxHr } = healthData

    let veryHight = maxHr;
    let hight = maxHr - 5;
    let low = minHr + 5;
    let veryLow = minHr;

    function getDataOldOpacity() {
        var delta = (Date.now() - lastUpdate * 1000)
        if (delta > 3600000) {
            return "opacity-25" // more than 1 hour
        } else if (delta > 1200000) {
            return "opacity-50" // more than 20 minutes
        } else if (delta > 600000) {
            return "opacity-75" // more than 10 minutes
        } else return null
    }

    function getDataOldTimeStamp() {
        var delta = (Date.now() - lastUpdate * 1000)
        if (delta > 3600000 * 5) {
            return t("time.more_than_n_ago", { duration: "5h" }) // more than 5 hours
        } else if (delta > 3600000) {
            return t("time.more_than_n_ago", { duration: "1h" }) // more than 1 hour
        } else if (delta > 1200000) {
            return t("time.more_than_n_ago", { duration: "20 m" }) // more than 20 minutes
        } else if (delta > 600000) {
            return t("time.more_than_n_ago", { duration: "10 m" }) // more than 10 minutes
        } else return <>{t("property.updated_at_time")} {new Date(lastUpdate * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</>
    }

    function getSafeRangeColor() {
        if (hr == null) {
            return "bg-dark bg-opacity-25";
        }
        if (hr >= low && hr <= hight) {
            return "bg-dark bg-opacity-0";
        } else if ((hr > hight && hr <= veryHight) || (hr < low && hr >= veryLow)) {
            return "bg-warning bg-opacity-25";
        } else {
            return "bg-danger bg-opacity-25";
        }
    }

    function getHeartIcon() {
        if (hr == null) {
            return <i></i>;
        }
        if (hr >= low && hr <= hight) {
            return <i className="fa-solid fa-heart fa-fade text-danger"></i>;
        } else if ((hr > hight && hr <= veryHight) || (hr < low && hr >= veryLow)) {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-warning"></i>;
        } else {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-danger"></i>;
        }
    }

    return <>


        <div className={`text-center py-2 ${getDataOldOpacity()}`}>
            {
                isOffBody ?

                    <h5><i className="fa-solid fa-hand"></i> OffBody</h5>
                    : <span>
                        <span className={`h3 font-bold p-1`}>
                            {getHeartIcon()} {hr || "-- "}
                        </span>
                        <small className="text-muted">bpm</small>
                    </span>
            }

        </div>
        <div className="mb-2">
            <small className="text-muted mb-2"> {getDataOldTimeStamp()}</small>
        </div>



    </>

}